module.exports = __webpack_public_path__ + "static/media/iconmonstr-github-3.5afe3e66.svg";